// Newsletter Configuration
// Update these values with your Beehiiv details

export const newsletterConfig = {
  // Enable/Disable newsletter subscription
  enabled: true,
  
  // Newsletter provider: 'beehiiv', 'mailchimp', 'custom'
  provider: 'custom',  // Changed to 'custom' since we're using our own backend

  // Beehiiv Configuration
  beehiiv: {
    embedUrl: 'https://magic.beehiiv.com/v1/4a966af2-b8a7-4ee4-a61b-9257312e3e24?email={{email}}',
    publicationName: 'Focus-View',
  },

  // Display settings
  display: {
    // Show floating button (bottom right)
    showFloatingButton: true,

    // Show in header/navigation
    showInHeader: true,

    // Show in footer
    showInFooter: true,

    // Button text
    buttonText: 'Subscribe',

    // Call to action
    ctaText: 'Get the latest AI, Crypto & Politics news',

    // Dogecoin wallet collection
    collectDogecoinWallet: true,

    // Maximum wallets to collect (wallet field disables after this)
    maxWallets: 100,
  },

  // Styling
  style: {
    // Button color
    primaryColor: '#667eea',

    // Button hover color
    hoverColor: '#764ba2',
  }
};

export default newsletterConfig;